import $ from "jquery";
import "slick-carousel";

const sliderHero = () => {
  const init = () => {
    exec();
  };

  const exec = () => {
    const el = {
      parent: ".mi-hero-slider",
      targetUp: ".mi-hero-slider.up",
      targetDown: ".mi-hero-slider.down",
    };

    if ($(el.parent).length === 0) return;

    $(document).ready(function () {
      $(el.targetUp).slick({
        speed: 2000, // (ms)
        autoplay: true,
        autoplaySpeed: 1,
        centerMode: false,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableHeight: true,
        infinite: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        waitForAnimate: false,
        useCSS: false,
        vertical: true,
        verticalSwiping: false,
      });

      $(el.targetDown).slick({
        speed: 2000, // (ms)
        autoplay: true,
        autoplaySpeed: 1,
        centerMode: false,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableHeight: true,
        infinite: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        waitForAnimate: false,
        useCSS: false,
        vertical: true,
        verticalSwiping: false,
        // rtl: true,
      });
    });
  };

  init();
};

try {
  sliderHero();
} catch (e) {
  console.error(e);
}
